// Consolidados mensuales del "Control diario de producción" (colección controlproduccionconsolidados).
// El backend recalcula cada consolidado desde los datos del sistema.

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const BASE = `${API_URL}/control-produccion/consolidados`;

const handleResponse = async (response, errorMsg) => {
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    let message = text;
    try { message = JSON.parse(text)?.message || text; } catch (_) { /* texto plano */ }
    throw new Error(`${errorMsg}: ${message || response.statusText}`);
  }
  return response.json();
};

export const generarConsolidado = async ({ laundryIds, year, month, generadoPor }) => {
  const response = await fetch(`${BASE}/generar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ laundryIds, year, month, generadoPor }),
  });
  const json = await handleResponse(response, 'Error al generar el consolidado');
  const result = json?.data?.results?.[0];
  if (result?.status === 'error') throw new Error(result.error || 'Error al generar el consolidado');
  return json?.data;
};

export const listarConsolidados = async ({ laundryId, year }) => {
  const params = new URLSearchParams();
  if (laundryId) params.append('laundryId', laundryId);
  if (year) params.append('year', String(year));
  const response = await fetch(`${BASE}?${params.toString()}`);
  const json = await handleResponse(response, 'Error al obtener los consolidados');
  return Array.isArray(json?.data) ? json.data : [];
};

export const eliminarConsolidado = async (id) => {
  const response = await fetch(`${BASE}/${id}`, { method: 'DELETE' });
  return handleResponse(response, 'Error al eliminar el consolidado');
};
